<<script>
    import AdminList from '../_List';
    import TableRow from './_Row';

    export default {
        extends: AdminList,

        data: () => ({
            cols: ['Kunde', 'Adresse', 'Erstellt', ''],
            TableRow,
            removeRow: null,
            removeModal: {
                text: 'Soll dieser Kunde wirklich gelöscht werden?',
                button: 'Kunde löschen',
                error: 'Der Kunde konnte nicht gelöscht werden.',
            },
        }),
    };
</script>
